"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _axiosRetry = _interopRequireDefault(require("axios-retry"));

var _cleanHeaders = _interopRequireDefault(require("./utils/cleanHeaders"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var REFRESH_ACCESS_TOKEN_PATH = 'auth/token/refresh';
var INVALID_TOKEN = 'INVALID_TOKEN';

var OlyEngineApi = function () {
  function OlyEngineApi(config) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, OlyEngineApi);
    (0, _defineProperty2["default"])(this, "_axios", void 0);
    (0, _defineProperty2["default"])(this, "_waitTokenReady", Promise.resolve(undefined));
    (0, _defineProperty2["default"])(this, "_accessToken", void 0);
    (0, _defineProperty2["default"])(this, "_isTokenRefreshing", false);
    (0, _defineProperty2["default"])(this, "_refreshToken", void 0);
    (0, _defineProperty2["default"])(this, "_storeAccessToken", void 0);
    (0, _defineProperty2["default"])(this, "_onLogout", void 0);
    (0, _defineProperty2["default"])(this, "_tokenApiUrl", void 0);
    (0, _defineProperty2["default"])(this, "_clientId", void 0);
    (0, _defineProperty2["default"])(this, "_deviceId", void 0);
    (0, _defineProperty2["default"])(this, "_deviceName", void 0);
    var headers = config.headers,
        _config$tokenConfig = config.tokenConfig,
        storeAccessToken = _config$tokenConfig.storeAccessToken,
        tokenApiUrl = _config$tokenConfig.tokenApiUrl,
        refreshToken = _config$tokenConfig.refreshToken,
        accessToken = _config$tokenConfig.accessToken,
        clientId = _config$tokenConfig.clientId;
    var headersWithoutDevice = (0, _omit["default"])(headers, ['x-device-id', 'x-device-name', 'timezone']);
    this._axios = _axios["default"].create({
      headers: (0, _cleanHeaders["default"])(headersWithoutDevice)
    });
    this._storeAccessToken = storeAccessToken;
    this._tokenApiUrl = tokenApiUrl;
    this._refreshToken = refreshToken;
    this._accessToken = accessToken;
    this._clientId = clientId;
    this._deviceId = undefined;
    this._deviceName = undefined;

    this._onLogout = function () {
      return Promise.resolve();
    };

    this._axios.interceptors.response.use(function (response) {
      return response;
    }, function () {
      var _ref = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(error) {
        var _error$response, _error$response2, _error$response2$data;

        var originalRequest, deviceId, deviceName, _accessToken, _ref2, response;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                originalRequest = error.config;
                deviceId = headers['x-device-id'], deviceName = headers['x-device-name'];

                if (!(((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401 && ((_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.name) === INVALID_TOKEN && !originalRequest._retry)) {
                  _context.next = 22;
                  break;
                }

                _context.prev = 3;
                originalRequest._retry = true;
                _context.next = 7;
                return _this.refreshAccessToken({
                  deviceId: deviceId,
                  deviceName: deviceName
                });

              case 7:
                _accessToken = _context.sent;
                _this._accessToken = _accessToken;
                originalRequest.headers['Authorization'] = _accessToken;
                _this._isTokenRefreshing = false;
                return _context.abrupt("return", _this._axios(originalRequest));

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](3);
                _ref2 = _context.t0, response = _ref2.response;

                if (!((response === null || response === void 0 ? void 0 : response.status) === 401)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 20;
                return _this._onLogout();

              case 20:
                _this._isTokenRefreshing = false;
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 22:
                return _context.abrupt("return", Promise.reject(error));

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 14]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }

  (0, _createClass2["default"])(OlyEngineApi, [{
    key: "getAndStoreAccessToken",
    value: function () {
      var _getAndStoreAccessToken = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2(_ref3) {
        var deviceId, deviceName, _yield$this$_axios$po, _yield$this$_axios$po2, accessToken;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                deviceId = _ref3.deviceId, deviceName = _ref3.deviceName;
                _context2.next = 3;
                return this._axios.post("".concat(this._tokenApiUrl).concat(REFRESH_ACCESS_TOKEN_PATH), {
                  refreshToken: this._refreshToken,
                  clientId: this._clientId
                }, {
                  headers: {
                    'x-device-id': deviceId || this._deviceId,
                    'x-device-name': deviceName || this._deviceName
                  }
                });

              case 3:
                _yield$this$_axios$po = _context2.sent;
                _yield$this$_axios$po2 = _yield$this$_axios$po.data;
                _yield$this$_axios$po2 = _yield$this$_axios$po2 === void 0 ? {} : _yield$this$_axios$po2;
                accessToken = _yield$this$_axios$po2.accessToken;

                if (!accessToken) {
                  _context2.next = 12;
                  break;
                }

                if (!this._storeAccessToken) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 11;
                return this._storeAccessToken(accessToken);

              case 11:
                return _context2.abrupt("return", accessToken);

              case 12:
                throw new Error('Error getting token');

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAndStoreAccessToken(_x2) {
        return _getAndStoreAccessToken.apply(this, arguments);
      }

      return getAndStoreAccessToken;
    }()
  }, {
    key: "refreshAccessToken",
    value: function refreshAccessToken(_ref4) {
      var deviceId = _ref4.deviceId,
          deviceName = _ref4.deviceName;

      if (!this._isTokenRefreshing) {
        this._isTokenRefreshing = true;
        this._waitTokenReady = this.getAndStoreAccessToken({
          deviceId: deviceId,
          deviceName: deviceName
        });
      }

      return this._waitTokenReady;
    }
  }, {
    key: "createRequest",
    value: function createRequest(baseUrl) {
      var _this2 = this;

      var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
      var apiOptions = arguments.length > 2 ? arguments[2] : undefined;
      return function () {
        var _ref5 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee3(url) {
          var requestOptions,
              withoutAuth,
              _apiOptions$retries,
              retries,
              authorization,
              apiOptionsDeviceId,
              apiOptionsDeviceName,
              _requestOptions$param,
              params,
              _requestOptions$data,
              data,
              _requestOptions$fullR,
              fullResponse,
              _requestOptions$heade,
              headers,
              _ref6,
              Authorization,
              withoutAuthHeader,
              cancelToken,
              source,
              deviceHeaders,
              finalHeaders,
              request,
              _args3 = arguments;

          return _regenerator["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  requestOptions = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                  withoutAuth = apiOptions.withoutAuth, _apiOptions$retries = apiOptions.retries, retries = _apiOptions$retries === void 0 ? 0 : _apiOptions$retries, authorization = apiOptions.authorization, apiOptionsDeviceId = apiOptions.deviceId, apiOptionsDeviceName = apiOptions.deviceName;
                  _requestOptions$param = requestOptions.params, params = _requestOptions$param === void 0 ? null : _requestOptions$param, _requestOptions$data = requestOptions.data, data = _requestOptions$data === void 0 ? null : _requestOptions$data, _requestOptions$fullR = requestOptions.fullResponse, fullResponse = _requestOptions$fullR === void 0 ? false : _requestOptions$fullR, _requestOptions$heade = requestOptions.headers, headers = _requestOptions$heade === void 0 ? {} : _requestOptions$heade;
                  _ref6 = headers, Authorization = _ref6.Authorization, withoutAuthHeader = _ref6.withoutAuth;
                  cancelToken = _axios["default"].CancelToken;
                  source = cancelToken.source();

                  if (retries) {
                    (0, _axiosRetry["default"])(_this2._axios, {
                      retries: retries
                    });
                  }

                  _context3.prev = 7;
                  _context3.next = 10;
                  return _this2._waitTokenReady;

                case 10:
                  _context3.next = 15;
                  break;

                case 12:
                  _context3.prev = 12;
                  _context3.t0 = _context3["catch"](7);
                  console.log('Error getting token');

                case 15:
                  deviceHeaders = {};

                  if (apiOptionsDeviceId && apiOptionsDeviceName || _this2._deviceId && _this2._deviceName) {
                    deviceHeaders = {
                      'x-device-id': apiOptionsDeviceId || _this2._deviceId,
                      'x-device-name': apiOptionsDeviceName || _this2._deviceName
                    };
                  }

                  finalHeaders = withoutAuth || withoutAuthHeader ? _objectSpread({}, headers, {
                    Authorization: null
                  }, apiOptions) : _this2._refreshToken ? _objectSpread({}, headers, {}, deviceHeaders, {}, apiOptions, {
                    Authorization: _this2._accessToken
                  }) : _objectSpread({}, headers, {}, deviceHeaders, {}, apiOptions, {
                    Authorization: Authorization || authorization && authorization()
                  });
                  request = _this2._axios({
                    baseURL: baseUrl,
                    cancelToken: source.token,
                    data: data,
                    headers: (0, _cleanHeaders["default"])(finalHeaders),
                    method: method,
                    params: params,
                    url: url
                  }).then(function (res) {
                    return fullResponse ? res : res.data;
                  })["catch"](function (e) {
                    if (_axios["default"].isCancel(e)) {
                      return Promise.reject(new Error("".concat(baseUrl).concat(url, " - Request cancel")));
                    }

                    if (e.response && e.response.statusText !== 'OK' || e.message === 'Network Error') {
                      var _e$response, _e$response2;

                      var errorData = e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.data;
                      var errorStatus = e === null || e === void 0 ? void 0 : (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.status;
                      return Promise.reject(errorData ? _objectSpread({
                        status: errorStatus
                      }, errorData) : e);
                    }

                    return e;
                  });
                  return _context3.abrupt("return", {
                    request: request,
                    cancel: source.cancel
                  });

                case 20:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[7, 12]]);
        }));

        return function (_x3) {
          return _ref5.apply(this, arguments);
        };
      }();
    }
  }, {
    key: "setDevice",
    value: function setDevice(_ref7) {
      var id = _ref7.id,
          name = _ref7.name;
      this._deviceId = id;
      this._deviceName = name;
    }
  }, {
    key: "addCommonHeaders",
    value: function addCommonHeaders(headers) {
      var _this3 = this;

      if (headers && (0, _typeof2["default"])(headers) === 'object') {
        Object.keys(headers).forEach(function (headerKey) {
          return _this3._axios.defaults.headers.common[headerKey] = headers[headerKey];
        });
      }
    }
  }, {
    key: "storeAccessToken",
    set: function set(value) {
      this._storeAccessToken = value;
    }
  }, {
    key: "onLogout",
    set: function set(value) {
      this._onLogout = value;
    }
  }, {
    key: "accessToken",
    set: function set(value) {
      this._accessToken = value;
    }
  }, {
    key: "refreshToken",
    set: function set(value) {
      this._refreshToken = value;
    }
  }]);
  return OlyEngineApi;
}();

exports["default"] = OlyEngineApi;
//# sourceMappingURL=olyEngineApi.js.map